import { fromJS } from 'immutable';
const KEY = 'bogSettings';
export function request(state) {
    return state.setIn([ KEY, 'state'], 'IN_PROGRESS');
}

export function error(state, { errors }) {
    return state.setIn([ KEY, 'state' ], 'ERROR').setIn([ KEY, 'errors' ], errors);
}

export function finish(state, { data }) {
    return state
        .setIn([ KEY, 'data' ], fromJS(data))
        .setIn([ KEY, 'state' ], 'FINISHED');
}

